module.exports = __webpack_public_path__ + "img/battery_1purple.c39dc825.png";